export default "__VITE_ASSET__B401IjKP__"